import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-admin'
import { API } from '../../helpers/Api.helper'
import { Artwork } from '../../types/Artwork'

type ArtworkTargetProps = {
  artworkId: Artwork['id']
}

export const ArtworkTarget = ({ artworkId }: ArtworkTargetProps) => {
  const artworkQuery = useQuery<Artwork>({
    queryKey: ['artworks', artworkId],
    queryFn: async () => {
      const response = await API.get<Artwork>(`/api/artworks/${artworkId}`)

      return response.data
    },
  })

  return (
    <Link to={`/artworks/${artworkQuery.data?.id}/show/prepayments`}>
      {artworkQuery.data?.name}
    </Link>
  )
}
